import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=230c9d9e&scoped=true&"
import script from "./CalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEvent.vue?vue&type=style&index=0&id=230c9d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c9d9e",
  null
  
)

export default component.exports